// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__HkHmk","header":"editor_header__VAkHu"};